import { Chip, Divider, Grid, Link, Typography } from '@mui/material';

import { Organization, AssociatedEntity } from 'components/Labels';
import { getFullUserNameOrId } from 'helpers';
import { OrganizationVerboseProps } from 'types';

export type OrganizationReviewProps = {
  organization: OrganizationVerboseProps;
};

export const OrganizationReview = (props: OrganizationReviewProps) => {
  const { organization } = props;
  const {
    name,
    // country,
    // id,
    children,
    parent,
    // candidates,
    users,
    parent_id,
  } = organization;
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant='h4'>{name} </Typography>
        {parent_id ? <AssociatedEntity /> : <Organization />}{' '}
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ mb: 2 }} />
      </Grid>
      <Grid item xs={12}>
        {parent && (
          <>
            <Typography sx={{ mt: 2 }} variant='h5'>
              Parent Employer
            </Typography>
            <Link href={`/home/auditor_dashboard/employers/${parent.id}`}>
              {parent.name}
            </Link>
          </>
        )}

        {children.length > 0 && (
          <>
            <Typography sx={{ mt: 2 }} variant='h5'>
              Associated Entities:
            </Typography>
            {children.map((child) => (
              <Chip
                key={`${child.id}`}
                sx={{ mr: 1 }}
                clickable
                label={child.name}
                component='a'
                href={`/home/auditor_dashboard/employers/${child.id}`}
              />
            ))}
          </>
        )}
      </Grid>
      {users.length > 0 && (
        <>
          <Typography sx={{ mt: 2 }} variant='h5'>
            Users:
          </Typography>
          {users.map((user) => (
            <Chip
              key={`${user.id}`}
              sx={{ mr: 1 }}
              clickable
              label={getFullUserNameOrId(user)}
              component='a'
              href={`/home/auditor_dashboard/users?email=${user.email}`}
            />
          ))}
        </>
      )}
    </Grid>
  );
};
